import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { decode } from 'html-entities';

@Component({
  selector: 'fal-fal-modal',
  templateUrl: './fal-modal.component.html',
  styleUrls: ['./fal-modal.component.scss']
})
export class FalModalComponent implements OnInit, OnDestroy {
  modalDetails?: string[];
  @Input()
  events!: Observable<string[]>;
  showModal = false;
  eventSubscription = new Subscription();
  ngOnInit(): void {
    if (!!this.events) {
      this.eventSubscription = this.events.subscribe((data) => {
        this.modalDetails = data;
        this.showModal = true;
      });
    }
  }
  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
  }
  decodeHtml(decodeStr: string) {
    return decode(decodeStr);
  }
}
